import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_PATHS } from '../config/api-paths';
import { ModificationsApi } from '../tokens/modifications.token';
import {
  ModificationRequest,
  ModificationSubmitRequest,
  ModificationSubmitResponse,
} from '../models/financing-servicing.model';

/**
 * REST-only implementation of `ModificationsApi` (EPIC-4 / EM-500, Story 10 — EM-510).
 *
 * Calls the Story-6 `ModificationResource` (loan-id-keyed) under `/services/embedded/api/loans`.
 * Owner-only server-side (SUBMIT_MODIFICATION). Rides the Keycloak bearer. Rule 07 / Rule 10 — no
 * Mock. Rule 09 — the raw `HttpErrorResponse` propagates (per-type validation 400s surface).
 */
@Injectable()
export class ModificationsRestService implements ModificationsApi {
  private readonly http = inject(HttpClient);

  list(loanId: string): Observable<ModificationRequest[]> {
    return this.http.get<ModificationRequest[]>(`${API_PATHS.LOANS}/${encodeURIComponent(loanId)}/modifications`);
  }

  submit(loanId: string, request: ModificationSubmitRequest): Observable<ModificationSubmitResponse> {
    return this.http.post<ModificationSubmitResponse>(
      `${API_PATHS.LOANS}/${encodeURIComponent(loanId)}/modifications`,
      request,
    );
  }
}
